<template>
  <div class="activity">
    <div class="bg-top"></div>
    <div class="container">
      <div class="list" v-for="(item, index) in data" :key="index">
        <div class="list-right">
          <img @click="toGame()" :src="item.img" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { post } from "../../util/http";
import { mapMutations, mapState } from "vuex";

export default {
  name: "game",

  data() {
    return {
      active: true,
      data: [
        {
          text1: "2022/04/20-2022/06/16",
          text2: "猎鹰直播版本更新说明",
          text3: "新版本 新体验",
          img: require("./img1.jpg"),
        },
        {
          text1: "2022/04/20-2022/06/16",
          text2: "猎鹰主播招募",
          text3: "招募活动火热进行中",
          img: require("./img2.jpg"),
        },
      ],
      gameUrl: "",
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },

  async mounted() {
    // if (this.userInfo.id) {
    //   await this.getGameUrl();
    // }
  },
  methods: {
    ...mapMutations(["toggleLogin"]),

    async getGameUrl() {
      const {
        data: { data },
      } = await post({
        url: "/api/game/login",
      });
      this.gameUrl = data.url;
      console.log(this.gameUrl, "data game url");
    },
    async toGame() {
      if (this.userInfo.id) {
        await this.getGameUrl();
        window.open(this.gameUrl, "_blank");
        // this.$router.push({ name: "gameDetail", params: { url: this.gameUrl } });
      } else {
        this.toggleLogin();
      }
      console.log(this.gameUrl);
    },
  },
};
</script>

<style scoped lang="scss">
.activity {
  margin-top: 156px;
  // position: relative;

  .container {
    margin: 0 auto;
    margin-bottom: 40px;
    width: 1000px;
    .toggle {
      display: flex;
      font-size: 16px;
      color: #999;
      margin: 28px 0;
      .active {
        color: #000;
      }
      .tab {
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;

        .bar {
          margin-top: 5px;
          width: 32px;
          height: 4px;
          background-color: #02a8a2;
          border-radius: 2px;
        }
      }
      .going {
        margin-right: 28px;
      }
    }
    .list {
      display: flex;
      margin-bottom: 30px;
      .list-left {
        width: 345px;
        height: 178px;
        padding: 35px 0;
        background-color: #fff;
        border-radius: 10px 0px 0px 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
        .col1 {
          font-size: 12px;
          color: #999;
        }
        .col2 {
          font-size: 18px;
          color: #333;
          font-weight: bold;
        }
        .col3 {
          font-size: 14px;
          color: #999;
        }
        .col4 {
          width: 108px;
          height: 33px;
          background: linear-gradient(90deg, #29f19c 0%, #02a1f9 100%);
          border-radius: 5px;
          color: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }
      }
      .list-right {
        flex: 1;

        img {
          width: 100%;
          height: 100%;
          border-radius: 0px 10px 10px 0px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
